const eventDetails = (
  state: any = {},
  action: any
) => {
  switch (action.type) {
    case 'SET_EVENT_DETAILS':
      return action.payload
    case 'CLOSE_EVENT_DETAILS':
      return {}
    default:
      return state
  }
}

export default eventDetails
